import type { BarProps } from 'recharts'
import { NyuLineProperties } from '../../../shared/types'
import { Shape } from './Shapes'

type ShapeBarProps = BarProps &
    NyuLineProperties & {
        payload?: Record<string, number>
        dataKey: string
        barShapeScale?: number
        layout: 'vertical' | 'horizontal'
    }

export function ShapeBar({
    layout,
    x,
    y,
    width = 10,
    height = 10,
    barShapeScale = 1,
    dataKey,
    payload = {},
    ...rest
}: ShapeBarProps) {
    if (typeof payload[dataKey] === 'undefined') {
        return null
    }

    const isHorizontal = layout === 'horizontal'
    const minSize = 10
    const maxSize = 30
    const numWidth = Number(width)
    const numHeight = Number(height)
    const barSize = isHorizontal ? numWidth : numHeight
    const rawSize = 13 * barShapeScale * (barSize / 10)
    const size = Math.max(Math.min(rawSize, maxSize), minSize)

    const dx = isHorizontal ? (numWidth - size) / 2 : -size / 2 + numWidth
    const dy = isHorizontal ? -size / 2 : (numHeight - size) / 2

    return <Shape {...rest} size={size} x={Number(x) + dx} y={Number(y) + dy} />
}
